class SearchFilter extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
    this.inputs = this.querySelectorAll("input[type='checkbox'], input[type='radio']");
    this.form = this.querySelector("form");
    this.sectionId = this.dataset.sectionId;
    this.collectionContainer = document.querySelector("#ProductGridContainer");
    this.closeButton = this.querySelectorAll("[data-close]");
    this.filterLinks = this.querySelectorAll("[data-filter-link]");
    this.productContainer = document.querySelector('[data-product-results]');
  }

  connectedCallback() {
    if (this.isInitialized) return; // Prevent re-initialization
    this.isInitialized = true;

    // Event listeners
    this.filterLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const url = new URL(e.currentTarget.href);
        this.fetchCollection(url.href);
      });
    });

    this.form.addEventListener('change', (e) => {
      if (e.target.matches("input[type='checkbox'], input[type='radio']")) {
        const label = e.target.closest('label');
        if (e.target.checked) {
          label.classList.add('active');
        } else {
          label.classList.remove('active');
        }
        this.handleFilter();
      }
    });

    this.closeButton.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.remove("mobile-filter-open");
        const event = new CustomEvent("mobile-filter:close", { bubbles: true });
        this.dispatchEvent(event);
      });
    });

    const radioInputs = this.querySelectorAll("input[type='radio']");
    if (radioInputs.length > 0) {
      if (Array.from(radioInputs).some((input) => input.checked)) {
        return;
      }
      radioInputs[0].checked = true;
      const label = radioInputs[0].closest("label");
      label.classList.add("active");
      // Don't call handleFilter() here to avoid immediate recursion on reconnect
    }
  }

  handleFilter() {
    const searchParams = this.createSearchParams(this.form);
    this.submitForm(searchParams);
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData);
  }

  submitForm(searchParams) {
    const url = new URL(window.location.href);

    const qValue = url.searchParams.get('q');

    [...url.searchParams.keys()].forEach(key => {
      if (key !== 'q') url.searchParams.delete(key);
    });

    searchParams.forEach((value, key) => {
      url.searchParams.append(key, value);
    });

    if (qValue) {
      url.searchParams.set('q', qValue);
    }

    this.fetchCollection(url.href);
  }

  fetchCollection(url) {
    history.replaceState("", "", url);

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const parsedHTML = new DOMParser().parseFromString(responseText, "text/html");
        const newContainer = parsedHTML.querySelector("#ProductGridContainer");

        if (newContainer && this.collectionContainer) {
          this.collectionContainer.innerHTML = newContainer.innerHTML;

          // Replace <search-filter> inside container without re-initializing event listeners
          const newFilter = this.collectionContainer.querySelector("search-filter");
          if (newFilter) {
            // Replace it with a clone to upgrade custom elements but avoid infinite loop
            const clone = newFilter.cloneNode(true);
            newFilter.replaceWith(clone);
            customElements.upgrade(clone);
          }
          document.dispatchEvent(new CustomEvent("search:updated"));
        }
      })
      .catch(err => {
        console.error("Error fetching filtered collection:", err);
      });
  }
}

if (!customElements.get("search-filter")) {
  customElements.define("search-filter", SearchFilter);
}